import { useDispatch } from 'react-redux';

import { TDispatch } from '../../types/redux';

export const useAppDispatch: () => TDispatch = useDispatch;
